import { Component, OnInit, Input } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { OTIOrderSplitDetails } from '../../../models/OTI/OTIOrderSummaryVM';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-oti-grid-view',
  templateUrl: './oti-grid-view.component.html',
  styleUrls: ['./oti-grid-view.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class OtiGridViewComponent implements OnInit {
  gridDataList: any;
  plAccess = false;
  itemList = new Array();
  @Input()
  set gridData(val: OTIOrderSplitDetails) {
    this.gridDataList = val.productDetail;
  }
  get gridData(): OTIOrderSplitDetails {
    return this.gridDataList;
  }
  displayedColumns: string[] = ['product', 'detail', 'quantity', 'orderUOM', 'packageSize'];
  displayedFooterColumns: string[] = this.displayedColumns;

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.plAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.ORDER_TO_INVOICE_VIEW_PRICING, MasterConstants.USER_ACCESS.EDIT_FULL);
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
